// 专门放优惠券券包的特例，因为总有各种沙雕的需求，没办法的
import { isLZWKAPP } from '../utils'
import Config from "../config";


export function CouponListSpecial(content) {
    try {
        let prefix = Config.MAIN_URL

        const testAInviter_id = [44006949, 44814268, 44814368, 52439452, 52439551, 52440369, 54460715, 54460755, 54460799]
        const testBInviter_id = [53845374, 53845447, 54460640, 53845210, 53845263, 53845298, 55790658, 55790717, 55790861,46717336]

        if (isLZWKAPP() && +content.coupon.bag_id === 26) return location.assign(`/activity/app_luck_draw?bag_id=${content.coupon.bag_id}&inviter_id=${content.inviter_id}`)
        if (isLZWKAPP() && +content.coupon.bag_id === 28) return location.assign(`/activity/app_winter?bag_id=${content.coupon.bag_id}&inviter_id=${content.inviter_id}`)

        if (+content.coupon.bag_id === 47) {
            const inviter_id = content.inviter_id
            const versionA = [44006949,44814268,44814368,61329026]
            const versionB = [53845374,53845447,54460640]
            // 这个地方有一些沙雕逻辑 ，根据inviter_id指定去某个链接的ab版，或者直接指定去某个页面，

            if (versionA.includes(inviter_id)) {
                return location.assign(`${prefix}/coupons-bag/?bagid=47b&fr=couponlist`)
            } else if (versionB.includes(inviter_id)) {
                return location.assign(`${prefix}/coupons-bag/?bagid=47c&fr=couponlist`)
            } else {
                return location.assign(`${prefix}/coupons-bag/?bagid=47&fr=couponlist`)
            } 
        }

        if (content.coupon.bag_id === 52) {
            return location.assign(`https://business.tryweike.cn/operation-business/double-egg?fr=mycoupon`)
        }

        if(+content.coupon.bag_id >= 42) {
            return location.assign(`${content.coupon.url}`)
        }

        if(+content.coupon.bag_id > 29 && +content.coupon.bag_id < 42) {
            return location.assign(`${prefix}/coupons-bag/coupon?bagid=${content.coupon.bag_id}&inviter_id=${content.inviter_id}`)
        }

        if(+content.coupon.bag_id === 27) {
            return location.assign(`/specials/coupon?bagid=${content.coupon.bag_id}&version=7C`)
        }

        // === 22 的临时特例开始
        if(testAInviter_id.indexOf(content.inviter_id)>-1 && +content.coupon.bag_id === 22){
            if(isLZWKAPP()){
                return location.assign(`/specials/coupon?bagid=${content.coupon.bag_id}&version=7A&from=app`)
            }
            return location.assign(`/specials/coupon?bagid=${content.coupon.bag_id}&version=7A`)
        }

        if(testBInviter_id.indexOf(content.inviter_id)>-1 && +content.coupon.bag_id === 22){
            if(isLZWKAPP()){
                return location.assign(`/specials/coupon?bagid=${content.coupon.bag_id}&version=7B&from=app`)
            }
            return location.assign(`/specials/coupon?bagid=${content.coupon.bag_id}&version=7B`)
        }
        // === 22 的临时特例结束

        if (+content.coupon.bag_id === 8) {
            return location.assign(`/specials/coupon?bagid=8&inviter_id=${content.inviter_id}&is_hide_prize=1&is_new_people=1&wk_from=param_4`);
        } else {
            return location.assign(`/specials/activity/coupon_timeline?bag_id=${content.coupon.bag_id}`)
        }
    } catch(err) {
        console.log(err)
    }
}


// WEBPACK FOOTER //
// ./src/pages/CouponListSpecial.js